import { gql } from "@apollo/client";

export const DETAIL_APPOINTMENT = gql`
  query appointmentDetail($id: String!) {
    appointmentDetail(
      id: $id,
    ) {
      id,
      active,
      start_at,
      end_at,
      startDateTime,
      endDateTime,
      user {
        id,
        firstName,
        lastName,
        countryCode,
        phone,
        email,
        channelFoundUs,
        isEmailConfirmed,
        location,
      },
      duration,
      status,
      description,
      destination_address,
      pet {
         id,
              name,
              image,
              speciesName,
              breedName,
              species,
              breed,
              gender,
      },
      tasks {
        description,
        type,
      },
      reasonsForVisit,
      appointmentType,
      allowedToEdit,
      location {
        idLocation,
        locationName,
        address,
        city,
        position {
          lat,
          lng,
        },
        email,
        phoneNumber,
        timeZone,
      },
    }
  }
`;
